module.exports = __webpack_public_path__ + "img/eb22bcf.png";